import { Montserrat } from 'next/font/google';
import { valueof } from '@/types';

// eslint-disable-next-line new-cap
export const montserrat = Montserrat({
  weight: ['300', '400', '500', '600', '700'],
  subsets: ['latin'],
  display: 'swap'
});

export const COLOR = {
  GREY_30: '#f6f5f3'
};

export const COLOR_LABEL = {
  GREEN: 'green',
  BLUE: 'blue',
  RED: 'red',
  WHITE: 'white',
  PINK: 'pink'
};

export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const LINK_FORMATS = {
  LABEL: 'label',
  PARAGRAPHE: 'paragraphe'
} as const;

export const DESIGN_SYSTEM_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

export type DesignSystemSizesTypes = valueof<typeof DESIGN_SYSTEM_SIZES>;
